import { ChangeDetectionStrategy, HostListener, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Utils } from 'app/utils/utils';
import { CadastroService } from '../../../../../shared/services/cadastro.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Estados } from '../../../../../shared/inmemory-db/estados';
import { ModalidadeFrete } from '../../../../../shared/inmemory-db/modalidade-frete';
import { Estado } from '../../../../../shared/interfaces/estado';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { Log } from '../../../../../shared/interfaces/log';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderProgressService } from '../../../../../shared/services/app-loader-progress/app-loader-progress.service';
import { AppLoaderService } from '../../../../../shared/services/app-loader/app-loader.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { FatDoctoCUtilsService } from 'app/shared/services/fat-docto-c-utils.service';
import { TipoCadastro } from 'app/shared/inmemory-db/tipo-cadastro';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { CadastroTablePopupComponent } from 'app/views/cadastro/cadastros/cadastro/cadastro-table-popup/cadastro-table-popup.component';
import { BehaviorSubject, Observable, of, Subject, timer } from 'rxjs';
import { debounceTime, delay, filter, finalize, map, retry, share, switchMap, takeUntil, tap } from 'rxjs/operators';
import { PageResult } from 'app/shared/interfaces/page-result';
import { HttpErrorResponse } from '@angular/common/http';
import { Produto } from 'app/shared/interfaces/produto';
import { ProdutoService } from 'app/shared/services/produto.service';


@Component({
  selector: 'app-lancamento-transp',
  templateUrl: 'lancamento-transp.component.html',
  styleUrls: ['lancamento-transp.component.scss'],
})
export class LancamentoTranspComponent implements OnInit, OnDestroy {

  public doctoCForm: FormGroup;
  lcto: FatDoctoC;
  doctoIForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  modalidadesFrete: any[];
  estados: Estado[];

  errorMsg: string;

  private stopPolling = new Subject();

  utils = Utils;

  max = null;
  workDone = null;
  it = 0;
  maxRetry = 20;
  created = false;
  disabled: true;
  public layoutConf: any;

  transps: Cadastro[];
  transp: Cadastro;
  isLoadingTransp = false;

  motoristas: Cadastro[];
  motorista: Cadastro;
  isLoadingMotorista = false;

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  produtos: Produto[];
  produtos$: BehaviorSubject<Produto[]> = new BehaviorSubject<Produto[]>(null);
  produto: Produto;
  searching = false;

  protected _onDestroy = new Subject<void>();



  @HostListener('window:keyup.esc') onKeyUp() {
    if (this.dialog.openDialogs.length > 0) {
      console.log('@HostListener(window:keyup.esc) onKeyUp()');
      this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });     
    }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoTranspComponent>,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCService,
    private cadastroService: CadastroService,
    private snack: MatSnackBar,
    private loader: AppLoaderService,
    private progressLoader: AppLoaderProgressService,
    private layout: LayoutService,
    private produtoService: ProdutoService
  ) {
    this.modalidadesFrete = new ModalidadeFrete().modalidades;
    this.estados = new Estados().estados;
  }  

  ngOnInit() {
    console.log('INIT Transp');    
    this.layoutConf = this.layout.layoutConf;
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;

    //load produto with fatProdutoIdpred id if exists and > 0
    if (this.lcto.fatProdutoIdpred && this.lcto.fatProdutoIdpred > 0) {
      this.produtoService.getProdutoById(this.lcto.fatProdutoIdpred).subscribe(produto => {
        this.produto = produto;
        this.doctoCForm.patchValue({ produtoPred: produto });
        this.produtos$.next([produto]);
      });
    }

         /**
     * Search Produtos
     */
         this.doctoCForm.get('produtoSearch').valueChanges
         .pipe(
           filter(search => !!search),
           tap(() => this.searching = true),
           takeUntil(this._onDestroy),
           debounceTime(200),
           map(search => {
             return this.produtoService.getProdutoPageSearch(1, 10, search, 'NENHUM', 'ASC', false, false).subscribe(page => {
               this.produtos$.next(page.content);
             });
           }),
           delay(200),
           takeUntil(this._onDestroy)
         )
         .subscribe(result => {
           this.searching = false;
         },
           error => {
             this.searching = false;
             this.confirmService.confirm(
               {
                 message: `A T E N Ç Ã O !  ERRO PESQUISANDO TRANSAÇÃO ... ${error}`,
                 error: true
               });
           }); 
  }


  ngOnDestroy() {
    this.stopPolling.next();
  }
  askToSave(){     
    this.confirmService.confirm({ message: `Salvar Lançamento?` })
    .subscribe(res => {
      if (res) {
      }
    });
  } 
    
  private initLogItens() {
    this.it = 0;
    this.workDone = null;
    this.max = null;
  }

  save(previa = false, mostrarOk = true): BehaviorSubject<FatDoctoC> {
    const result = new BehaviorSubject<FatDoctoC>(null);
    const obs = new BehaviorSubject<Log>({} as Log);
    // this.loader.open();
    this.openProgressLoader(obs);
    // this.isSaving$.next(true);
    // this.itemForm.patchValue({ fatListaPrecoTabelaId: this.itemForm['fatListaPrecoTabela'].value?.id?.tabelaId });
    this.doctoCForm.patchValue({ cadastroVendedorId: this.doctoCForm['cadastroVendedorId'] });
    // this.doctoCForm.patchValue({ items: this.doctoIs$.value });
    this.fatDoctoCService.saveOrUpdate(this.doctoCForm.value).subscribe(val => {
      // this.buildDoctoCForm(val);
      console.log(val);
      this.deleteLog();
      if (!previa) {
        if(mostrarOk){
          this.snack.open(`SALVO COM SUCESSO!`, 'OK', { duration: 5500 });
          this.confirmService.confirm({
            title: 'SALVAR',
            message: 'OK, Lançamento Salvo com Sucesso!', error: false
          });
        }
      }
      result.next(val);
      // this.isSaving$.next(false);
      // this.loader.close();
    }, err => {
      // this.loader.close();
      this.deleteLog();
      result.error(err);
      // this.isSaving$.next(false);
      this.snack.open(`ERRO:${err.error.status}!`, 'ERRO', { duration: 5500 });
      this.confirmService.confirm({
        title: 'ERRO AO SALVAR, VERIFIQUE',
        message: err.error.status, error: true
      })
    });
    return result;
  }

  displayFnCadastro(cad: Cadastro) {
    if (cad) {
      // return `${cad.codigo.toString().padStart(6, '0')}`;
      return `${cad.codigo.toString().padStart(6, '0')} - ${cad.nomeFantasia.trim()}`;
    }
  }


   // TRANSPORTADOR
   onFocusTransp(event: FocusEvent) {
    this.doctoCForm.get('cadCadastroTransp').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => {

          this.isLoadingTransp = true;
        }),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ?
            this.cadastroService.getCadastroPageSearch(1, 10, value, null, null, false, TipoCadastro.TRANSPORTADORES) :
            this.cadastroService.getCadastroPage(1, 10, null, null, false, TipoCadastro.TRANSPORTADORES))
          : new Observable<PageResult<Cadastro>>())
          .pipe(
            finalize(() => this.isLoadingTransp = false),
          )
        )
      )
      .subscribe(transps => this.transps = transps.content);
  }


  onSelectionChangeTransp(event: any): void {
    if (event.option.value !== undefined) {
      this.transp = event.option.value;
      this.doctoCForm.patchValue({ transpNome: this.transp.razaoSocial });
      this.doctoCForm.patchValue({
        transpCnpjCpf: this.transp.pessoa === 'Fisica' ? this.transp.cpf : this.transp.inscricaoFederal
      });
      this.doctoCForm.patchValue({ transpCidade: this.transp.cadMun?.municipio });
      this.doctoCForm.patchValue({ transpUf: this.transp.cadMun?.uf });
      this.doctoCForm.patchValue({ transpEndereco: this.transp.endereco });
      this.doctoCForm.patchValue({ transpIeRg: this.transp.pessoa === 'Fisica' ? this.transp.rg : this.transp.inscricaoEstadual });
    }
  }

  addTransp() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(CadastroTablePopupComponent, {
      width: '1024px',
      disableClose: true,
      data: { title: 'Novo Transportador', payload: {} }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.cadastroService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('transp Salvo com sucesso!', 'OK', { duration: 5500 });
            this.transp = data;
            this.doctoCForm.patchValue({ cadCadastroTransp: data });
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao salvar !', 'ERRO', { duration: 5500 });
          })
      })

  }

  // MOTORISTAS
  onFocusMotorista(event: FocusEvent) {
    this.doctoCForm.get('cadCadastroMotorista').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingMotorista = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ?
            this.cadastroService.getCadastroPageSearch(1, 10, value, null, null, false, TipoCadastro.MOTORISTAS) :
            this.cadastroService.getCadastroPage(1, 10, null, null, false, TipoCadastro.MOTORISTAS))
          : new Observable<PageResult<Cadastro>>())
          .pipe(
            finalize(() => this.isLoadingMotorista = false),
          )
        )
      )
      .subscribe(motoristas => this.motoristas = motoristas.content);
  }


  onSelectionChangeMotorista(event: any): void {
    if (event.option.value !== undefined) {
      this.motorista = event.option.value;
    }
  }
  addMotorista() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(CadastroTablePopupComponent, {
      width: '1024px',
      disableClose: true,
      data: { title: 'Novo Motorista', payload: {} }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.cadastroService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('Motorista Salvo com sucesso!', 'OK', { duration: 5500 });
            this.motorista = data;
            this.doctoCForm.patchValue({ cadCadastroMotorista: data });
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao salvar !', 'ERRO', { duration: 5500 });
          })
      })
  }

  fixaPesoBruto() {
    this.doctoCForm.controls['fixaPesoBruto'].patchValue(true);
  }

  fixaPesoLiquido() {
    this.doctoCForm.controls['fixaPesoLiquido'].patchValue(true);
  }

  fixaVolumes() {
    this.doctoCForm.controls['fixaVolumes'].patchValue(true);
  }


  submit() {
    if (this.doctoCForm.valid) {
      console.log('form submitted');
      // this.dialogRef.close(this.itemForm.value)
    } else {
      this.validateAllFormFields(this.doctoCForm); // {7}
    }
  }

  /** UTILS */
  private deleteLog() {
    this.fatDoctoCService.deleteLog(this.lcto?.uuid).subscribe((log) => {
      this.progressLoader.close();
    });
  }

  private openProgressLoader(obs: BehaviorSubject<Log>) {
    this.progressLoader.open(obs);
    timer(1, 1500).pipe(
      switchMap(() => this.fatDoctoCService.getLog(this.lcto?.uuid)),
      retry(),
      share(),
      takeUntil(this.stopPolling)
    ).subscribe(valor => {
      if (this.max === valor.max && this.workDone === valor.workDone) {
        this.it = this.it + 1;
      } else {
        this.it = 0;
      }
      this.max = valor.max;
      this.workDone = valor.workDone;
      if ((valor.workDone !== null && valor.workDone !== undefined
        && valor.max != null && valor.max !== undefined
        && valor.workDone >= valor.max) || this.it === this.maxRetry) {
        this.stopPolling.next();
        this.initLogItens();
      }
      obs.next(valor);
    }, err => {
      this.loader.close();
      this.confirmService.confirm({
        title: 'ERRO AO EXECUTAR OPERAÇÃO',
        message: err.error.status, error: true
      });
    });
  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  isFieldValid(field: string) {
    return !this.doctoCForm.get(field).valid && this.doctoCForm.get(field).touched;
  }

  close() {
    this.dialogRef.close();
    // this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
    //   .subscribe(res => {
    //     if (res) {
    //         this.dialogRef.close();
    //     }
    //   });
  }

  onSelectionChangeProduto(event: any): void {
    console.log(event.value);
    
    if (event.value !== undefined) {
      this.doctoCForm.patchValue({ fatProdutoIdpred: event.value?.id });
      this.doctoCForm.patchValue({ produtoPred: event.value });

      this.produto = event.value;
    }
  }

}
